import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Invitation from './Invitation';

// El panel de admin (y su librería de Excel) se cargan aparte:
// así los invitados nunca descargan ese código al abrir su invitación.
const AdminPanel = lazy(() => import('./AdminPanel'));

function App() {
  return (
    <Routes>
      {/* Ruta 1: Home (Invitación Genérica) */}
      <Route path="/" element={<Invitation />} />

      {/* Ruta 2: Invitación Personalizada (ej: midominio.com/invitacion/familia-otto) */}
      <Route path="/invitacion/:id" element={<Invitation />} />

      {/* Ruta 3: Panel de Admin */}
      <Route
        path="/admin"
        element={
          <Suspense fallback={<div style={{ padding: 40, textAlign: 'center', fontFamily: 'system-ui' }}>Cargando panel…</div>}>
            <AdminPanel />
          </Suspense>
        }
      />

      {/* Ruta 4: Cualquier otra cosa redirige al home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;